import { createStore } from "vuex";
import { auth } from "../firebaseApp.js";
import { onAuthStateChanged, setPersistence, browserLocalPersistence } from "firebase/auth";

import messages from './messages.js'
import users from "./users.js";
import projects from './projects.js'
import clients from './clients.js'
import consumers from './consumers.js'
import instance from './instance.js'
import profiles from "./profiles.js";
import services from "./services.js";
import workers from './workers.js'

const store = createStore({
    state: {
        currentUser: null,
        instanceId: null,
        loggedIn: false,
    },
    getters: {},
    mutations: {
        setInstanceId(state, id) {
            state.instanceId = id
        },
        loginAttempt(state, payload) {
            state.loggedIn = payload
        },
        keepCurrentUser() {
            setPersistence(auth, browserLocalPersistence)
        },
    },

    actions: {
        currentUser({ commit }) {
            commit('keepCurrentUser')
        },
    },

    modules: {
        messages,
        users,
        projects,
        clients,
        consumers,
        instance,
        profiles,
        services,
        workers,
    },
});

onAuthStateChanged(auth, (user) => {
    store.commit('users/setCurrentUser', user)
})

export default store
